<template>
    <div class="ContentBox">
        <div class="commonBox TopsBlack"> <Tops :ishome="false"  @ChangeKeys="ChangeKeys"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
        <PathBox />
        <!--  -->
        <div class="ListMenuBox">
            <template v-if="Arrs.total>0">
               <ListItem v-for="(v,i) in Arrs['row']" :Item="v" :key="i"  @LookInfo="LookInfo"/>
            </template>
            <template v-else>
              <Error />
            </template>
            <el-pagination
                v-if="Arrs.total>0"
                style="margin-top:50px"
                :current-page.sync="CurrPage"
                :size-change="handleCurrentChange"
                :page-size="15"
                layout="total, prev, pager, next"
                :total="Arrs.total">
            </el-pagination>
        </div>
        <Footer />
    </div>
</template>
<script>
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import Error from "@/components/PubBox/Error.vue";
import ListItem from "@/components/ListBox/ListItem.vue";
import {GetInfoBySearch} from '@/requestPub/api';
export default {
    components:{
        Tops,Footer,PathBox,ListItem,Error
    },
    data() {
      return {
        Arrs:new Object(),
        CurrPage:1,
        IntTxt:''
      }
    },
    mounted(){
      this.IntTxt = this.$route.query.keys
      this.defaultInfo();
    },
    watch:{
      CurrPage(){
          this.defaultInfo();
      }
    },
    methods:{   
       defaultInfo(){
        let P ={
          did:1,
          selText:this.IntTxt,
          pageIndex:this.CurrPage,
          pageSize:15
        }
          GetInfoBySearch(P).then((e)=>{
              this.Arrs = e.Data
          })
      },
      ChangeKeys(n){
        this.IntTxt = n;
        this.CurrPage = 1;
        this.defaultInfo();
      },
      LookInfo(n){
        this.$router.push('/ListArtInfo?ids='+n.ids);
      },
      handleCurrentChange(val){
        this.CurrPage=val;
        this.defaultInfo();
      }
    }
}
</script>
<style lang="scss">
.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    p{
      text-indent: 40px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
    img{
      width: 100%;
    }
  }
  // ListMenuBox
  .ListMenuBox{
      width:1260px;
      margin: 60px auto 0;
      .MenuList{
        display: inline-flex;
        width:100%;
        margin-bottom: 20px;
        span{
          background:  #F5F5F5;;
          width:calc(100% / 3);
          padding: 5px 20px;
          // line-height: 30px;
          font-size: 15px;
          &:hover{
            cursor: pointer;
            //  color:#fff;
             transform: scale(1.03);
            // background: linear-gradient(90deg, #4160CE, #4160CE);
            transition: all .5s;
          }
        }
        span:nth-child(2){
          margin: 0 20px;
        }
        .act{
          color:#fff;
          background: linear-gradient(90deg, #4160CE, #4160CE);
        }
      }

  }
</style>